// =============================================================================
// Today — the SEVRIC Battery Care home, per-user customizable.
//
// Header is just a personal greeting. Weather lives as a draggable widget on
// the dashboard so you can place it wherever it actually helps you.
// =============================================================================
import { useAuth } from "../auth/AuthProvider.jsx";
import { DashboardGrid } from "../components/DashboardGrid.jsx";

export default function Today() {
  const { user, profile } = useAuth();
  const role = profile?.role || "default";
  const firstName = pickFirstName(profile, user);

  return (
    <main className="today-stage">
      <header className="today-head today-head-mini">
        <div className="today-greet">
          <h1 className="today-h1">{greeting()}, <em>{firstName}</em>.</h1>
        </div>
      </header>
      <DashboardGrid uid={user?.uid} role={role} />
    </main>
  );
}

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}
function pickFirstName(profile, user) {
  const candidate = profile?.name || profile?.displayName || user?.displayName || (user?.email || "").split("@")[0];
  if (!candidate) return "there";
  const first = candidate.split(/[ ._-]/).filter(Boolean)[0] || candidate;
  return first[0].toUpperCase() + first.slice(1);
}
